<template>
  <div class="box card-container" :class="appKey=='WX_MINI_JBH'?'jbhBg':'defaultBg'">
   <div class="h1 text-ellipsis-overflow-1">{{info.meetingName}}</div>
   <div class="content">
      <div class="h1 text-ellipsis-overflow-1" :class="appKey=='WX_MINI_JBH'?'jbhColor':'defaultColor'">邀请函</div>
      <div class="h2-title text-ellipsis-overflow-1" v-if="type=='EXHIBITION' || type=='HOLD_MEETING'">{{info.meetingName}}</div>
      <div class="h2-title text-ellipsis-overflow-1" v-if="type=='EXHIBITOR'">{{info.exhibitorName}}</div>
      <div class="h2-title text-ellipsis-overflow-1" v-if="type=='EXHIBIT'">{{info.exhibitName}}</div>
      <div class="h2-welcome text-ellipsis-overflow-1">诚邀莅临</div>
      <div class="btn" :class="info.both ? '' : 'invisible'">展位号：{{info.both}}</div>
      <img class="img" :src="info.cover" :class="info.cover ? '' : 'invisible'" alt="">
      <img class="scanCodeImg" :src="info.qrCodeUrl" :class="info.qrCodeUrl ? '' : 'invisible'" alt="">
   </div>
   <div class="footer">
      <div class="top">
        <img src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/images/time-icon.png" alt="" class="left left1">
        <div class="desc">{{info.startTime | forMatterTime}} - {{info.endTime | forMatterTime}}</div>
      </div>
      <div class="top name">
        <img src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/images/address-icon.png" alt="" class="left">
        <div class="desc text-ellipsis-overflow-1">{{info.address || ''}}</div>
      </div>
   </div>
  </div>
</template>
<script>
import wmtDate from "@/utils/date.js";
export default {
  name:'postCard',
  props:{
    customClass: {
			type: String,
			default: ""
		},
		type:{
			type: String,
			default: ""
		},
		info: {
			type: Object,
			default: ()=>({})
		},
   appKey:{
    	type: String,
			default: ""
   }
  },
  components:{},
  filters: {
		forMatterTime(val) {
			return wmtDate.fromatDate('yyyy/MM/dd', new Date(val));
		}
	},
  data() {
    return {}
  },
  methods: {},
  mounted() {}
}
</script>
<style lang="less" scoped>
  @font-face {
    font-family: 'MyFont';
    src: url('https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/WeMeet-mini/file/SourceHanSansSC-VF.woff2') format('woff2');
    // src: url('https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/WeMeet-mini/file/test.woff') format('woff');
    font-weight: normal;
    font-style: normal;
  }
  // div {
  //   font-family: 'MyFont', sans-serif !important;
  // }
  .defaultBg{
    background-color: #00C4C9;
  }
 
  .jbhBg{
    background-color: #0DAAFF;
  }
 
  .card-container {
  
    width: 750px;
    height: 1210px;
    border-radius: 20px;
    padding: 40px 40px 20px;
    box-sizing: border-box;
    font-family: 'MyFont', sans-serif !important;
    .h1 {
      color: #fff;
      font-weight: 700;
      font-size: 38px;
      text-align: center;
    }
    .content {
      width: 100%;
      height: 950px;
      margin-top: 40px;
      padding: 48px 30px;
      background: url('https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/images/inviteBg-n.png') no-repeat ;
      background-size: contain;
      .defaultColor{
    color: #00C4C9;
  }
  .jbhColor{
    color: #0DAAFF;
  }
      .h1 {
        font-weight: 700;
        font-size: 60px;
        text-align: center;
      }
      .h2-title {
        font-size: 34px;
        color: #262626;
        margin-top: 14px;
        text-align: center;
      }
      .h2-welcome {
        font-size: 34px;
        color: #262626;
        margin-top: 12px;
        text-align: center;
      }
      .btn {
        display: flex;
        align-items: center;
        width: fit-content;
        padding: 10px 34px;
        font-weight: 500;
        font-size: 36px;
        color: #FFFFFF;
        height: 60px;
        background: #00C4C9;
        border-radius: 30px;
        margin: 18px auto 0;
      }
      .img {
        display: block;
        width: 100%;
        height: 300px;
        border-radius: 24px;
        background-color: #F5F5F5;
        margin-top: 16px;
      }
      .scanCodeImg {
        display: block;
        width: 244px;
        height: 244px;
        background-color: #fff;
        margin: 28px auto 0;
      }
    }
    .footer {
      margin-top: 20px;
      .top {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 28px;
        color: #fff;
        text-align: center;
        .left {
          width: 36px;
          height: 36px;
          margin-right: 14px;
          flex-shrink: 0;
          margin-right: 10px;
        }
        .left1 {
          width: 30px;
          height: 30px;
        }
        .desc {
         max-width: calc(100vw - 174px);
        }
      }
      .name {
        margin-top: 6px;
      }
    }
  }
</style>